import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "artist-card in-genre-page" }
const _hoisted_2 = {
  key: 0,
  class: "artist-card-img-wrap"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "album-card-img-wrap"
}
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "artist-title" }
const _hoisted_8 = {
  key: 0,
  class: "artist-year text-center"
}
const _hoisted_9 = {
  key: 0,
  class: "style-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.artist.primary_img)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_RouterLink, {
              to: { path: '/meta/artist/'+_ctx.artist._id }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "card-img",
                  src: _ctx.artist.primary_img,
                  alt: _ctx.artist.name
                }, null, 8, _hoisted_3)
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_RouterLink, {
              to: { path: '/meta/album/'+_ctx.artist._id }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "card-img",
                  src: "/static/naimage.jpg",
                  alt: _ctx.artist.name
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }, 8, ["to"])
          ])),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RouterLink, {
            to: { path: '/meta/artist/'+_ctx.artist._id },
            class: "artist-name"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.artist.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.artist.begin_year)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[ " + _toDisplayString(_ctx.artist.begin_year) + " - " + _toDisplayString(_ctx.artist.end_year||'/') + " ]", 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showStyles)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artist.styles, (style) => {
                return (_openBlock(), _createBlock(_component_StyleTag, {
                  key: style._id,
                  genre: style,
                  full: 0
                }, null, 8, ["genre"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}